import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getPublicFormAction,
  isPublicFormValidAction,
} from "../../actions/PublicFormsActions";
import * as code from "../../config/Constants";
import * as message from "../../config/CommonMessages";
import UrlConstants from "../../config/UrlConstants";
import IntakePublic from "./IntakePublic";
import ConsentPublic from "./ConsentPublic";
import AftercarePublic from "./AftercarePublic";
import CheckInPublic from "./CheckInPublic";

var _ = require("lodash");

class PublicForms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      // isFormValid: false,
      showLoader: false,
    };
  }

  componentWillMount() {
    this.getPublicForms();
  }

  getPublicForms() {
    this.setState({
      showLoader: true,
    });
    // defines current browser location with params as defined in PublicForm route
    // i.e. /publicforms/:id?/:token?
    let queryString = this.props.match.params;

    // pulls id and token params from /publicforms/:id?/:token? route
    let id = queryString.id;
    let token = queryString.token;

    // initializes data object to be passed to API
    // uses pulled params variables initialized above
    let publicFormData = {
      id: id,
      token: token,
    };

    // calls public form data from API passing id and token and checks if valid
    this.props.getPublicFormAction(publicFormData).then((res) => {
      this.setState({
        formData: res,
        showLoader: false,
      });
      // this.props.isPublicFormValidAction(publicFormData).then((isValid) => {

      // if form is valid, sets returned form data in state to render in UI
      // if form is not valid, returns error message
      // if (this.props.isPublicFormValid) {
      //   this.setState({
      //     formData: res,
      //    isFormValid: true,
      //     showLoader: false,
      //   });
      // } else {
      //   this.setState({
      //     isFormValid: false,
      //     showLoader: false,
      //   });
      // }
      // });
    });
  }

  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-custom mt-5">
            {/* renders intake or consent public forms based on form data returned from API */}
            {
              this.state.formData.form === "intake" ? (
                <IntakePublic
                  history={this.props.history}
                  formData={this.state.formData}
                />
              ) : this.state.formData.form === "consent" ? (
                <ConsentPublic
                  formData={this.state.formData}
                  history={this.props.history}
                />
              ) : this.state.formData.form === "aftercare" ? (
                <AftercarePublic
                  formData={this.state.formData}
                  history={this.props.history}
                />
              ) : this.state.formData.form === "checkin" ? (
                <CheckInPublic
                  formData={this.state.formData}
                  history={this.props.history}
                />
              ) : (
                ""
              )
              // this.state.isFormValid === false &&
              //   this.state.showLoader === false ? (
              //   <p>
              //     This form has expired. Please contact your artist or studio to
              //     have it resent.
              //   </p>
              // ) : (
              //   ""
              // )
            }
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getPublicFormData: state.reducer.getPublicFormData,
    isPublicFormValid: state.reducer.isPublicFormValid,
  };
};

export default connect(mapStateToProps, {
  getPublicFormAction,
  isPublicFormValidAction,
})(PublicForms);
